var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOrangeHalfHexagon = function SvgOrangeHalfHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 352
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F17900",
    fillRule: "evenodd",
    d: "m45.476 351.072-170.554-62.076-31.518-178.743L-17.559-6.413l170.555 62.077 31.517 178.742z",
    opacity: 0.102
  })));
};
export default SvgOrangeHalfHexagon;